import { observer } from "mobx-react";
import { ArticleSelectorQuestion, LocalizedMarkdownQuestion } from "@/dbot/common/commonComponents";
import { ChangeSignatureInArticlesOfAssociationForm } from "./changeSignatureInArticlesOfAssociationDomain";
import { useEffect } from "react";
import { VBox } from "@/components-v2/Box";

import { useTranslation } from "@/stores/RootStoreContext";

export const ChangeSignatureInArticlesOfAssociationView = observer(
  function ChangeSignatureInArticlesOfAssociationView({
    form,
  }: {
    form: ChangeSignatureInArticlesOfAssociationForm;
  }) {
    const { t } = useTranslation();

    useEffect(() => {
      form.init();
    }, [form]);

    return (
      <VBox gap={"md"}>
        <ArticleSelectorQuestion
          question={t("decisions.signature.statutory")}
          model={form.paragraph}
          onChange={form.setParagraphValue}
          isLocked={form.isProjectLocked}
        />
        <LocalizedMarkdownQuestion
          textModels={form.texts}
          name={"article-text"}
          question={t("decisions.signature.statutory.newText")}
          isLocked={form.isProjectLocked}
        />
      </VBox>
    );
  },
);
